module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirmation"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "confirmation-wrap"
  }, [_c('h1', {
    staticClass: "font-big"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('confirmation_title')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-address"
  }, [_c('div', {
    staticClass: "confirmation-address-tab"
  }, _vm._l((_vm.tab), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "confirmation-address-tabItem1",
      on: {
        "click": function($event) {
          _vm.chooseOrder($event, index)
        }
      }
    }, [_c('div', {
      staticClass: "detail-btn",
      class: {
        selected: index == _vm.num
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "font-mid"
    }, [_vm._v(_vm._s(item.title))])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (this.type == 1) ? _c('div', {
    staticClass: "confirmation-address-ship"
  }, [_c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('about_ifree_join_sub_name'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipName),
      expression: "shipName"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('about_ifree_join_sub_name')
    },
    domProps: {
      "value": (_vm.shipName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('add_address_area'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipCountry),
      expression: "shipCountry"
    }],
    staticClass: "addr_country",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.shipCountry)
    },
    on: {
      "click": _vm.SelectCountry,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipCountry = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "left": "70%"
    },
    attrs: {
      "type": "arrow-down-b"
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.showCountry),
      expression: "this.showCountry"
    }],
    staticClass: "addr_item1_content"
  }, _vm._l((_vm.country_list), function(list, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selectTrue(1, list.country_name, list.id)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(list.country_name))])])
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('add_address_address'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item2"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipAddress),
      expression: "shipAddress"
    }],
    attrs: {
      "cols": "30",
      "rows": "6",
      "placeholder": _vm.$t('add_address_address_full')
    },
    domProps: {
      "value": (_vm.shipAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipAddress = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('add_address_zip_code')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipZipcode),
      expression: "shipZipcode"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('add_address_zip_code_full')
    },
    domProps: {
      "value": (_vm.shipZipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipZipcode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('user_center_email'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipEmail),
      expression: "shipEmail"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user_center_email')
    },
    domProps: {
      "value": (_vm.shipEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('confirmation_phone'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipPhone),
      expression: "shipPhone"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('about_ifree_join_sub_number')
    },
    domProps: {
      "value": (_vm.shipPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipPhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_tip"
  }, [_c('p', {
    staticClass: "font-small"
  }, [_vm._v(_vm._s(_vm.$t('confirmation_tip')))])]), _vm._v(" "), _c('div', {
    staticClass: "addr_btn"
  }, [_c('button', {
    on: {
      "click": _vm.checkAddr
    }
  }, [_vm._v(_vm._s(_vm.$t('confirmation_save')))])])]) : _c('div', {
    staticClass: "confirmation-address-ship"
  }, [_c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('about_ifree_join_sub_name'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.takeName),
      expression: "takeName"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('about_ifree_join_sub_name')
    },
    domProps: {
      "value": (_vm.takeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.takeName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('add_address_area'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.takeCountry),
      expression: "takeCountry"
    }],
    staticClass: "addr_country",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.takeCountry)
    },
    on: {
      "click": _vm.SelectCountry,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.takeCountry = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "left": "70%"
    },
    attrs: {
      "type": "arrow-down-b"
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.showCountry),
      expression: "this.showCountry"
    }],
    staticClass: "addr_item1_content"
  }, _vm._l((_vm.country_list), function(list, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selectTrue(2, list.country_name, list.id)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(list.country_name))])])
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('user_center_email'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.takeEmail),
      expression: "takeEmail"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user_center_email')
    },
    domProps: {
      "value": (_vm.takeEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.takeEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber font-mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('confirmation_phone'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.takePhone),
      expression: "takePhone"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('about_ifree_join_sub_number')
    },
    domProps: {
      "value": (_vm.takePhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.takePhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_tip"
  }, [_c('p', {
    staticClass: "font-small"
  }, [_vm._v(_vm._s(_vm.$t('confirmation_tip')))])]), _vm._v(" "), _c('div', {
    staticClass: "store"
  }, [_c('p', {
    staticClass: "font-mid"
  }, [_vm._v(_vm._s(_vm.$t('confirmation_close')))]), _vm._v(" "), _c('Row', _vm._l((_vm.store_list), function(list, index) {
    return _c('i-col', {
      key: index,
      attrs: {
        "lg": 12,
        "md": 12,
        "sm": 24,
        "xs": 24
      }
    }, [_c('div', {
      staticClass: "store_item",
      class: {
        ative: index == _vm.storeNum
      },
      on: {
        "click": function($event) {
          _vm.changeStore(index, list.id)
        }
      }
    }, [_c('p', {
      staticClass: "font-mid"
    }, [_vm._v(_vm._s(list.name))]), _vm._v(" "), (_vm.ShowThis == index) ? _c('div', {
      staticClass: "font-mid store_content"
    }, [_vm._v(_vm._s(list.address))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "store_more"
    }, [_c('a', {
      staticClass: "font-small",
      on: {
        "click": function($event) {
          _vm.ShowThisContent(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('add_address_address')) + " "), _c('Icon', {
      attrs: {
        "type": "chevron-right"
      }
    })], 1)])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "addr_btn"
  }, [_c('button', {
    on: {
      "click": _vm.checkAddr
    }
  }, [_vm._v(_vm._s(_vm.$t('confirmation_save')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-payment",
    staticStyle: {
      "display": "none"
    }
  }, [_c('steps', {
    attrs: {
      "current": 0
    }
  }, [_c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_1')
    }
  }), _vm._v(" "), _c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_2')
    }
  }), _vm._v(" "), _c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_3')
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a446880e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDetails/Confirmation.vue
// module id = 838
// module chunks = 0